export default {
  title: "Facturen die actie vereisen: {{total}}"
}
